/** Stable per passenger so simulation, progress and local audio agree without extra saved state. */
export function boardingCheck(serial: number): { kind: 'scan' | 'keyboard' | 'retry'; frames: number } {
  const check = Math.abs(serial * 37) % 100;
  if (check >= 90) return { kind: 'retry', frames: 54 };
  if (check >= 75) return { kind: 'keyboard', frames: 42 };
  return { kind: 'scan', frames: 18 };
}
